module.exports = __webpack_public_path__ + "img/235.3f3318aa.jpg";